(function () {
  function promoteCollectionImages() {
    var selectors = [
      ".template-collection .gp-product-images-gallery img[data-src]",
      ".template-collection .gp-featured-image-wrapper img[data-src]",
      ".template-search .gp-product-images-gallery img[data-src]",
      ".template-search .gp-featured-image-wrapper img[data-src]"
    ];
    var images = document.querySelectorAll(selectors.join(","));
    images.forEach(function (image, index) {
      if (index > 17) return;
      var src = image.getAttribute("data-src");
      if (!src || image.getAttribute("src") === src) return;
      image.setAttribute("src", src);
      if (image.getAttribute("data-srcset")) {
        image.setAttribute("srcset", image.getAttribute("data-srcset"));
      }
      image.setAttribute("loading", index < 6 ? "eager" : "lazy");
      image.setAttribute("decoding", "async");
    });
  }

  promoteCollectionImages();
  document.addEventListener("DOMContentLoaded", promoteCollectionImages);
})();
